

import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import { Checkbox, CheckboxGroup, Popup } from 'vant';

export default {
components: {
XHeader,
Group,
Cell,
PopupRadio,
Datetime,
XInput,
Radio,
Checklist,
PopupPicker
},
data () {
return {
showEditMobile:false,
sex: '男',
minYear: 1950,
sexList: ["男","女"],
model:{},
userInfo:{},
show:true,
show_language: false,
show_imgUpload: false,
Langs: [],
u_sangs:[],
area_source: [],
area_value: [],
labels: [],
u_label: "",
u_img: require('../../assets/tx.png'),
userPhoto: ''
}
},
created(){
this.getUserInfo();
this.getLang();
this.getArea();
},
methods: {
goBack(){
this.$router.push({
path : '/user/index',
query : {}
})
},
getUserInfo(){
var sef=this
this.model.token= this.getToken();
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getUserInfo',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
console.log(res.body);
sef.userInfo= res.body.data;
sef.sex=(sef.userInfo.sex!=null&&sef.userInfo.sex==1)?'女':'男';

if(sef.userInfo.language!=null){
sef.u_sangs=sef.userInfo.language.split('、')
}
if(sef.userInfo.userProvince!=null&&sef.userInfo.userCity!=null){
sef.area_value[0]=sef.userInfo.userProvince+'';
sef.area_value[1]=sef.userInfo.userCity+'';

}
if(sef.userInfo.userLabel!=null && sef.userInfo.userLabel.length>0){
sef.labels=sef.userInfo.userLabel.split('、')
}
if(res.body.photo!=null && res.body.photo!=""){
sef.u_img=res.body.photo;
sef.userPhoto=res.body.photo;
}
}else{
alert(res.body.message);
}
},function(res){
});
},
nickNameCheck(value, $event){
if(!value){
this.promptInformation("信息","昵称不能为空");
}
var reg=new RegExp("[^a-zA-Z0-9\_\u4e00-\u9fa5]","i");
if(reg.test(value)==true){
this.promptInformation("信息","昵称含有非法字符");
}
},
relNameCheck(value, $event){
var reg=new RegExp("[^a-zA-Z0-9\_\u4e00-\u9fa5]","i");
if(reg.test(value)==true){
this.promptInformation("信息","真实姓名含有非法字符");
}
},
addUserLabel(){

if(this.u_label.trim().length>0){
this.labels.push(this.u_label)
}
this.u_label="";
this.showEditMobile=false;
},
delectLabes(index){
this.labels.splice(index, 1);
},
hideArea(closeType){
if(closeType){
console.log(this.area_value);
}
},
getArea(){
var sef=this
this.model.token= this.getToken();
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getArea1',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{

sef.area_source=JSON.parse(res.body.data);
}else{
alert(res.body.message);
}
},function(res){
console.log(res.status);
});
},
getLang(){
var sef=this
this.model.token= this.getToken();
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getLang',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
sef.Langs= res.body.data;
}else{
alert(res.body.message);
}
},function(res){
console.log(res.status);
});
},
toggle(index,value) {
this.$refs.checkboxes[index].toggle();

var index = this.u_sangs.indexOf(value);
if (index > -1) {
this.u_sangs.splice(index, 1);
}else{
this.u_sangs.push(value)
}
this.userInfo.language=this.u_sangs.join('、')




},
goOut(){
this.promptInformation("信息","退出成功");
this.removeUser()

this.$router.push('/auth/login')
},
goChange(){
this.$router.push({
path : '/user/changePassword',
query : {
token: this.$route.query.token
}
})
},
notAllowedModify(){
this.$vux.alert.show({
title:"消息",
content:"移动端暂不支持手机换绑，请登录电脑端进行相关操作！",
onShow(){
console.log("I'm showing");
}
})
},
promptInformation(title,content){
this.$vux.alert.show({
title:title,
content:content,
})
},
fileClick(){
document.getElementById('img1').click()
},
uploadIMG(e) {
let files = e.target.files || e.dataTransfer.files;
if (!files.length) return;
this.picavalue = files[0];
this.imgSize=this.picavalue.size / 1024;

if (this.picavalue.size / 1024 > 8000) {
this.$message({
message: "图片过大不支持上传",
type: "warning"
});
} else {
this.imgPreview(this.picavalue);
}
},

imgPreview(file, callback) {
let self = this;

if (!file || !window.FileReader) return;
if (/^image/.test(file.type)) {

let reader = new FileReader();


reader.readAsDataURL(file);

reader.onloadend = function() {
let result = this.result;
let img = new Image();
img.src = result;

img.onload = function() {
let data;

if(self.imgSize>5000){
data = self.compress(img);
}else{
data = result;
}

self.imgUrl = result;

var imgs =document.getElementById("imgs1");
imgs.src=data
self.u_img=imgs.src;
self.show_imgUpload=false;
let blob = self.dataURItoBlob(data);

var formData = new FormData();
formData.append("file", blob);
formData.append("imgType", file.name);
self.addImag(formData)
};
};
}
},

addImag(formData){
let config = {
headers: { "Content-Type": "multipart/form-data" }
};
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/addImage',formData,config,{emulateJSON:true}).then(function(res){
this.userPhoto = res.body.src

this.show=false
this.show_imgUpload=false
},function(res){
console.log(res.status);
});
},

compress(img) {
let canvas = document.createElement("canvas");
let ctx = canvas.getContext("2d");
let initSize = img.src.length;
let width = img.width;
let height = img.height;
canvas.width = width;
canvas.height = height;

ctx.fillStyle = "#fff";
ctx.fillRect(0, 0, canvas.width, canvas.height);
ctx.drawImage(img, 0, 0, width, height);


let ndata = canvas.toDataURL("image/jpeg", 0.8);



return ndata;
},

dataURItoBlob(base64Data) {
var byteString;
if (base64Data.split(",")[0].indexOf("base64") >= 0)
byteString = atob(base64Data.split(",")[1]);
else byteString = unescape(base64Data.split(",")[1]);
var mimeString = base64Data
.split(",")[0]
.split(":")[1]
.split(";")[0];
var ia = new Uint8Array(byteString.length);
for (var i = 0; i < byteString.length; i++) {
ia[i] = byteString.charCodeAt(i);
}
return new Blob([ia], { type: mimeString });
},
saveUserInfo(){
var self=this
this.userInfo.sex=(this.sex!=null&&this.sex=='女')?1:0;
this.userInfo.userProvince=this.area_value[0]
this.userInfo.userCity=this.area_value[1]
this.userInfo.userLabel=this.labels.join('、')
if(this.userPhoto){
this.userInfo.userPhoto=this.userPhoto;
}





if(!this.userInfo.nickName){
this.promptInformation("信息","昵称不能为空");
return;
}


this.model.token= this.getToken();
this.model.userInfo= JSON.stringify(this.userInfo)
console.log(this.model.userInfo);

this.$http.post(this.global.httpUrl + '/rest/v1/m/user/saveUserInfo',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
self.promptInformation("信息","修改成功");
}else{
alert(res.body.message);
}
},function(res){
console.log(res.status);
});

}
}
}



// WEBPACK FOOTER //
// ./src/views/user/editInfo.vue